export default "__VITE_ASSET__a66THBsT__"